import { render, staticRenderFns } from "./mastercalSynchro.vue?vue&type=template&id=239c7236&"
import script from "./mastercalSynchro.vue?vue&type=script&lang=js&"
export * from "./mastercalSynchro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports